import { motion } from 'framer-motion';
import { cn } from '../../lib/cn';
import { springDefault } from '../../tokens';

type ProgressDotsProps = {
  total: number;
  current: number;
  className?: string;
};

/**
 * Onboarding progress indicator. The active dot widens into a small pill
 * (iOS Health-style); inactive dots are circles. Smooth springs between
 * states so back-tracking feels natural.
 */
export function ProgressDots({ total, current, className }: ProgressDotsProps) {
  return (
    <div
      role="progressbar"
      aria-valuenow={current + 1}
      aria-valuemin={1}
      aria-valuemax={total}
      className={cn('flex items-center justify-center gap-2', className)}
    >
      {Array.from({ length: total }, (_, i) => {
        const active = i === current;
        return (
          <motion.span
            key={i}
            layout
            transition={springDefault}
            className={cn(
              'h-2 rounded-pill',
              active ? 'bg-accent w-6' : 'bg-text-tertiary/30 w-2',
            )}
          />
        );
      })}
    </div>
  );
}
